import React from 'react'
import classnames from 'classnames'
import PropTypes from 'prop-types'
import Nav from '../nav/Nav'
import style from './Header.module.scss'
import Logo from '../logo/Logo'
import ContactBtn from '../buttons/ContactBtn/ContactBtn'
import LangSwitcher from '../lang/LangSwitcher'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import { DesktopPlusNot, DesktopPlus } from '../mediaQueries/MediaQueries'
import { injectIntl } from 'react-intl'
import EventOutside from '../eventOutside/eventOutside'

class Header extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      showMobile: false,
      scrolled: false,
      menuNav: this.props.intl.messages.nav,
      contactBtn: this.props.intl.messages.contactBtn,
    }
  }

  static propTypes = {
    intl: PropTypes.object,
  }

  componentDidMount() {
    window.addEventListener('scroll', this.handleScroll)
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll)
  }

  handleScroll = () => {
    window.pageYOffset > 50
      ? this.setState(() => ({ scrolled: true }))
      : this.setState(() => ({ scrolled: false }))
  }

  showMenu = () => {
    this.setState(prevState => {
      return { showMobile: !prevState.showMobile }
    })
  }

  closeMenu = () => {
    this.setState(() => ({ showMobile: false }))
  }

  render() {
    const { showMobile, scrolled, menuNav, contactBtn } = this.state

    return (
      <header
        className={classnames(
          style.container,
          scrolled ? style.containerScrolled : ''
        )}
      >
        <Logo />
        <DesktopPlus>
          <Nav menuNav={menuNav} />
        </DesktopPlus>
        <div className={style.navGroup}>
          <ContactBtn contactBtn={contactBtn} />
          <LangSwitcher />
          <DesktopPlusNot>
            <div className={style.bars}>
              <FontAwesomeIcon onClick={this.showMenu} icon={['fas', 'bars']} />
              <EventOutside func={this.closeMenu}>
                <Nav
                  showMobile={showMobile}
                  classNames={style.mobileMenu}
                  menuNav={menuNav}
                />
              </EventOutside>
            </div>
          </DesktopPlusNot>
        </div>
      </header>
    )
  }
}

export default injectIntl(Header)
